import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

// Rotas onde o botão de instalação NÃO deve aparecer (login/cadastro/públicas)
const HIDDEN_PREFIXES = [
  '/auth-tk',
  '/cadastro',
  '/ativacao',
  '/forgot-password',
  '/reset-password',
  '/avaliar',
  '/player/register',
  '/player/login',
  '/login',
];

const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
};

const PWAInstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setVisible(true);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setVisible(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const isHiddenRoute = HIDDEN_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));

  if (!visible || !deferredPrompt || isStandalone() || isHiddenRoute) {
    return null;
  }

  const handleInstallClick = async () => {
    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice;
    } finally {
      setDeferredPrompt(null);
      setVisible(false);
    }
  };

  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={handleInstallClick}
      style={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: 2000,
        borderRadius: 24,
        height: 44,
        paddingInline: 20,
        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
      }}
    >
      Instalar app
    </Button>
  );
};

export default PWAInstallButton;
